import { render, staticRenderFns } from "./UpdatePost.vue?vue&type=template&id=14e7cffb&scoped=true&"
import script from "./UpdatePost.js?vue&type=script&lang=js&"
export * from "./UpdatePost.js?vue&type=script&lang=js&"
import style0 from "./UpdatePost.vue?vue&type=style&index=0&id=14e7cffb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e7cffb",
  null
  
)

export default component.exports